export default __webpack_public_path__ + "static/media/menu-cobrancas.89c99987.svg";